import { lazy, Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { DHSCheckInsuranceLoading } from "./DHSCheckInsurance.loading";
import { DHSCheckInsuranceProps } from "./DHSCheckInsurance.types";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useFeatureFlag } from "../FeatureFlag/FeatureFlagsProvider";

export const DHSCheckInsuranceLoadable = lazy(
  () => import("./DHSCheckInsurance")
);

type WrapperProps = Omit<DHSCheckInsuranceProps, "i18next" | "useTranslation"> & {
  onReset?: () => void;
};

export const DHSCheckInsuranceWrapper = (props: WrapperProps) => {
  const useTranslationFn = useTranslation;
  const dhsEnabled = useFeatureFlag("FEATURE_DHS_INTEGRATION");
  const { user } = props;

  if (!dhsEnabled || !user?.permissions?.checkDhsInsurance) return null;

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<DHSCheckInsuranceLoading />}>
        <DHSCheckInsuranceLoadable
          {...(props as DHSCheckInsuranceProps)}
          i18next={i18next}
          useTranslation={useTranslationFn}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

export { DHSCheckInsuranceWrapper as DHSCheckInsurance };
